"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPerformance = function IconPerformance(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5061 5.84438C25.5921 4.74316 26.5545 3.92017 27.6557 4.00617C28.4038 4.0646 29.1413 4.16228 29.8661 4.29725C39.6174 6.11306 47 14.6631 47 24.9418C47 26.0463 46.1046 26.9418 45 26.9418C43.8954 26.9418 43 26.0463 43 24.9418C43 16.6249 37.0256 9.6992 29.1339 8.22965C28.5478 8.12051 27.9507 8.04139 27.3443 7.99403C26.2431 7.90802 25.4201 6.94559 25.5061 5.84438ZM24.4662 5.89732C24.6684 6.98322 23.952 8.02744 22.8661 8.22965C20.9704 8.58265 19.1854 9.25043 17.5665 10.1774C16.608 10.7262 15.386 10.3941 14.8371 9.43554C14.2883 8.47699 14.6204 7.25499 15.5789 6.70613C17.5799 5.56044 19.7884 4.73401 22.1339 4.29725C23.2198 4.09504 24.264 4.81142 24.4662 5.89732ZM14.0513 10.0344C14.8285 10.8192 14.8224 12.0855 14.0376 12.8628C13.3417 13.5521 12.705 14.3009 12.136 15.101C11.4958 16.0011 10.2471 16.2118 9.34702 15.5716C8.4469 14.9314 8.2362 13.6827 8.8764 12.7826C9.5788 11.795 10.3644 10.871 11.2229 10.0207C12.0077 9.24347 13.274 9.24957 14.0513 10.0344ZM8.9793 16.2542C10.0102 16.6508 10.5243 17.8081 10.1277 18.839C9.95503 19.2877 9.80087 19.7456 9.66616 20.2118C9.35947 21.2729 8.25063 21.8845 7.18949 21.5778C6.12835 21.2711 5.51674 20.1623 5.82343 19.1012C5.99013 18.5244 6.18088 17.9578 6.3945 17.4026C6.79116 16.3717 7.94841 15.8575 8.9793 16.2542ZM7.06813 22.3663C8.17221 22.3992 9.04058 23.3209 9.00769 24.425C9.00258 24.5965 9 24.7688 9 24.9418C9 26.0463 8.10457 26.9418 7 26.9418C5.89543 26.9418 5 26.0463 5 24.9418C5 24.7291 5.00317 24.5171 5.00946 24.3058C5.04236 23.2018 5.96405 22.3334 7.06813 22.3663Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.596 24.2135L35.5626 18.2469L35.5632 18.2463C36.2064 17.6031 36.0947 16.4485 35.3136 15.6675C34.5326 14.8864 33.378 14.7747 32.7348 15.4179L27.0083 21.1444C25.5971 20.6389 23.9586 20.9514 22.8283 22.0817C21.2662 23.6438 21.2662 26.1764 22.8283 27.7385C24.3904 29.3006 26.9231 29.3006 28.4852 27.7385C29.4441 26.7796 29.8144 25.4549 29.596 24.2135Z",
    fill: color
  }));
};

IconPerformance.defaultProps = {
  color: 'black'
};
IconPerformance.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconPerformance;
exports.default = _default;